<template>
  <!-- Header -->
  <div class="header">
    <div class="container">
      <router-link class="site-logo" to="/">
        <img src="@/assets/image/frontlogo.png" alt="BTC">
        <h5 class="sub-text">必孚（中国）</h5>
      </router-link>
      <!-- Mobile Button -->
      <a href="#" class="mobi-toggler"><i class="fa fa-bars"/></a>
      <!-- Navigation -->
      <div class="header-navigation pull-right font-transform-inherit">
        <ul class="nav-list">
          <li>
            <router-link to="/BTCTrend" class="dropdown-toggle" data-toggle="dropdown" data-target="#" href="javascript:;">必孚动态</router-link>
          </li>
          <!-- 必孚资讯 -->
          <li>
            <router-link to="/BTCInfo" class="dropdown-toggle" data-toggle="dropdown" data-target="#" href="javascript:;">必孚信息</router-link>
            <ul class="dropdown-menu">
              <li><router-link :to="{ path: '/section', query: { sectionid: '_beefpicked', sectiontitle: '必孚多肉' }}">必孚多肉</router-link></li>
              <li><router-link :to="{ path: '/section', query: { sectionid: '_beefnewsandevents', sectiontitle: '必孚牛肉' }}">必孚牛肉</router-link></li>
              <li><router-link :to="{ path: '/section', query: { sectionid: '_porknews', sectiontitle: '必孚猪肉' }}">必孚猪肉</router-link></li>
            </ul>
          </li>
          <!-- 必孚数据 -->
          <li>
            <router-link to="#" class="dropdown-toggle" data-toggle="dropdown" data-target="#" href="javascript:;">必孚数据</router-link>
            <ul class="dropdown-menu">
              <li class="dropdown-submenu">
                <router-link to="/BTCData" class="dropdown-toggle" data-toggle="dropdown" data-target="#" href="javascript:;">
                  <span>牛肉</span>
                  <i class="fa fa-angle-right"/>
                </router-link>
                <ul class="dropdown-menu">
                  <li><router-link to="/BTCData/BeefExportToChina" data-target="#" href="javascript:;">全球牛肉输华走势</router-link></li>
                  <li><router-link to="/BTCData/GlobalBeefExport" data-target="#" href="javascript:;">全球牛肉出口格局</router-link></li>
                  <li><router-link to="/BTCData/ChinaBeefImportDataChart" data-target="#" href="javascript:;">中国牛肉进口走势</router-link></li>
                  <li><router-link to="/BTCData/ChinaBeefImportDataReport" data-target="#" href="javascript:;">中国牛肉进口格局</router-link></li>
                </ul>
              </li>
              <li class="dropdown-submenu">
                <router-link to="/Pork/PTCData" class="dropdown-toggle" data-toggle="dropdown" data-target="#" href="javascript:;">
                  <span>猪肉</span>
                  <i class="fa fa-angle-right"/>
                </router-link>
                <ul class="dropdown-menu">
                  <li><router-link to="/Pork/PTCData/PorkExportToChina" data-target="#" href="javascript:;">全球猪肉输华走势</router-link></li>
                  <li><router-link to="/Pork/PTCData/GlobalPorkExports" data-target="#" href="javascript:;">全球猪肉出口格局</router-link></li>
                  <li><router-link to="/Pork/PTCData/ChinaPorkImports" data-target="#" href="javascript:;">中国猪肉进口格局</router-link></li>
                </ul>
              </li>
            </ul>
          </li>
          <!-- 必孚行情 -->
          <li>
            <router-link to="/BTCPrice" class="dropdown-toggle" data-toggle="dropdown" data-target="#" href="javascript:;">必孚行情</router-link>
          </li>
          <!-- 必孚肉集 -->
          <li @mouseleave="showQrcode=false">
            <router-link to="/BTCMarket" class="dropdown-toggle" data-toggle="dropdown" data-target="#" href="javascript:;">必孚肉集</router-link>
            <!-- <ul class="dropdown-menu">
              <li><router-link to="/BTCMarket" data-target="#" href="javascript:;">必孚智推</router-link></li>
              <li style="position: relative">
                <a data-target="#" href="javascript:;" @click="showQrcode=true">必孚集市</a>
                <market-dialog v-if="showQrcode" id="marketDialog" style="position: absolute; top: 0px; left: 120px;" @close="showQrcode=false"/>
              </li>
            </ul> -->
          </li>
          <!-- 必孚工厂 -->
          <li>
            <a class="dropdown-toggle" data-toggle="dropdown" data-target="#" href="javascript:;">必孚工厂</a>
            <ul class="dropdown-menu">
              <li><a data-target="#" href="javascript:;" @click="setMarketIndexTab">牛肉</a></li>
              <li><router-link to="/Pork/PTCEst" data-target="#" href="javascript:;">猪肉</router-link></li>
            </ul>
          </li>
          <!-- 必孚第三方服务 -->
          <li>
            <a class="dropdown-toggle" data-toggle="dropdown" data-target="#" href="javascript:;">必孚服务</a>
            <ul class="dropdown-menu">
              <li><router-link to="/BTCFinancial" data-target="#" href="javascript:;">期货代理金融</router-link></li>
              <li><router-link to="/BTCSale" data-target="#" href="javascript:;">现货代理采销</router-link></li>
            </ul>
          </li>
          <!-- 必孚破壳 -->
          <!-- <li>
            <router-link style="height: 84px; padding: 22px 12px;" to="/Pork/PTCInfo" class="dropdown-toggle" data-toggle="dropdown" data-target="#" href="javascript:;">
              <img src="@/assets/image/pork_logo_cn.png" height="40px;">
            </router-link>
          </li> -->
          <!-- 搜索 -->
          <li class="menu-search">
            <span class="sep"/>
            <i class="fa fa-search search-btn" @click="handelClick"/>
            <div :class="{ showSearchBox: showSearch }" class="search-box">
              <form>
                <div class="input-group col-xs-5 pull-left" style="padding-right: 10px;">
                  <select v-model="country" type="text" class="form-control">
                    <option value="" label="所有国家"/>
                    <option v-for="item in countryOptions" :key="item.value" :value="item.value">{{ $t(`message['${item.value}']`) }}</option>
                    <option value="_other" label="其他"/>
                  </select>
                </div>
                <div class="input-group col-xs-7 pull-left">
                  <input v-model="keyWords" type="text" placeholder="请输入关键字" class="form-control">
                  <span class="input-group-btn">
                    <button class="btn btn-primary" @click.prevent="handleSearch">搜索</button>
                  </span>
                </div>
              </form>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { newsCountryData } from '@/utils/dictionary'
import MarketDialog from '@/components/GoMarket'
export default {
  name: 'Header',
  components: {
    MarketDialog
  },
  data() {
    return {
      country: '',
      showSearch: false,
      keyWords: '',
      showQrcode: true
    }
  },
  computed: {
    countryOptions() {
      // const arr = []
      // let porkData = []
      // let beefData = []
      // porkData = porkData.concat(porkcountrydata)
      // beefData = beefData.concat(newsCountryData)
      // const all = this.intersection(porkData, beefData)
      // for (const i of all) {
      //   arr.push({ value: i })
      // }
      // return arr
      return newsCountryData.map(v => {
        return { value: v }
      })
    }
  },
  created() {
    window.addEventListener('mouseup', this.handleMouseup)
    this.$router.onError((error) => {
      const pattern = /Loading chunk (\d)+ failed/g
      const isChunkLoadFailed = error.message.match(pattern)
      const targetPath = this.$router.history.pending.fullPath
      if (isChunkLoadFailed) {
        this.$router.replace(targetPath)
      }
    })
  },
  methods: {
    handelClick() {
      this.showSearch = !this.showSearch
      return this.showSearch
    },
    handleMouseup(event) {
      if (this.showSearch && (event.target.nodeName !== 'INPUT' && event.target.nodeName !== 'SELECT')) {
        this.showSearch = false
      }
    },
    handleSearch() {
      if (this.country || this.keyWords) {
        this.$router.push({ path: '/search', query: { keywords: this.keyWords, country: this.country }})
        this.keyWords = ''
        this.country = ''
      }
    },
    intersection(arr1, arr2) {
      for (const item of arr1) {
        if (!arr2.includes(item)) {
          arr2.push(item)
        }
      }
      return arr2.sort()
    },
    setMarketIndexTab() {
      this.$store.commit('SET_MARKETINDEXTAB', '_approve_status')
      this.$router.push('/BTCPlant')
    }
  }
}
</script>

<style scoped>
.header { margin-bottom: 0!important; }
a { text-decoration: none; padding: 14px}
.site-logo { margin: 0 }
.site-logo:link    { color: #E02222;}
.site-logo:visited { color: #E02222;}
.site-logo:hover   { color: #E02222;}
.site-logo:active  { color: #E02222;}
.sub-text { font-size: 13px; margin: 2px 0 0 0; }
.nav-list { font-size:19px;}
.showSearchBox { display: inline!important }
.mobi-toggler { margin-left: 1px;}
.dropdown-submenu:hover .dropdown-menu { display: block; }
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Navigation/index.vue